import React, { useCallback, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'

import Button from '../Button'

import { ReactComponent as ExitDelete } from '../../assets/ExitDelete.svg'

import { Container, BlockWishList, ExiteButtonContainer } from './styles'

interface IModalProps {
    isOpen: boolean;
    onClick?: () => void;
    onClose?: () => void;
    classNameModal?: string;
    classNameBackdropModal?: string;
    classNameButton?: string;
    contentButton: React.ReactNode | string;
}

const Modal: React.FC<IModalProps> = ({
    isOpen,
    onClose,
    onClick,
    classNameModal,
    classNameBackdropModal,
    classNameButton,
    contentButton,
    children }) => {

    const nodeRef = useRef(null)

    const onCloseBackdropHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'backdrop') {
            return onClose ? onClose() : null
        }
    }, [onClose])

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={200} classNames="opacity__effect" unmountOnExit>
            <Container ref={nodeRef} id='backdrop' onClick={(event: React.ChangeEvent<HTMLInputElement> | any) => onCloseBackdropHandler(event)} className={classNameBackdropModal} >
                <BlockWishList className={classNameModal}>
                    {
                        onClose &&
                        <ExiteButtonContainer>
                            <ExitDelete className="svg__exit--button" onClick={onClose} />
                        </ExiteButtonContainer>

                    }
                    {children}
                    {
                        onClick &&
                        <Button onClick={onClick} className={`btn__modal ${classNameButton}`} name={contentButton} />
                    }
                </BlockWishList>
            </Container>
        </CSSTransition>
    )
}

export default Modal
